import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductPricelist } from '../models/product-pricelist';


@Injectable()
export class PricelistService {

  getPricelistById(pricelistId: number): Observable<ProductPricelist> {
    throw new Error('Method not implemented.');
  }

  getDefaultPricelist(): Observable<ProductPricelist> {
    throw new Error('Method not implemented.');
  }

}
